(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.agendasettings');
    module.factory('DayschemeTimesService', ['$rootScope', '$translate', '$filter', 'HelperService', 'Weekday', 'DayScheme', 'DaySchemeTime', 'DayStartEndTime', 'SchemeBroadcast', DayschemeTimesServiceFn]);

    function DayschemeTimesServiceFn($rootScope, $translate, $filter, HelperService, Weekday, DayScheme, DaySchemeTime, DayStartEndTime, SchemeBroadcast) {

        var service = {
            init: init,
            selectDay: selectDay,
            select: select,
            prepareForCopy: prepareForCopy,
            stopCopy: stopCopy,
            paste: paste,
            clear: clear
        };

        // public data
        service.data = {
            keyDown: false, // is left mouse key down
            label: {}, // currently selected label
            interval: 0, // agenda interval
            weekStartDay: null, // week-start-day of agenda
            weekdays: []  // the week 
        };

        return service;

        // clear
        function clear() {
            service.data.weekdays = [];
        }

        // generate week scheme
        function generate(daySchemes) {
            service.data.weekdays = []; // reinit

            var start = service.data.weekStartDay;

            // depending on starting-weekday of agenda
            angular.forEach(Weekday, function (day) {
                if (day !== Weekday.Holiday) {

                    // get right index (day-value - start-day-value)
                    var index = day.value - start;
                    if (index < 0) {
                        index = 7 - Math.abs(index);
                    }
                  
                    // generate
                    var ds = generateDay(day, daySchemes);

                    // push to list
                    service.data.weekdays[index] = ds;
                }
            });

        } // generate

        // generate one day in week
        function generateDay(weekday, daySchemes) {
            // is current weekday in existing daySchemes present ?
            var present = $filter('filter')(daySchemes, { 'weekday': weekday.value })[0];

            // new dayscheme object
            var dayscheme = new DayScheme();
            // if present -> extend
            if (present !== null && typeof present !== 'undefined') {
                dayscheme.extend(present);
            } //if
            dayscheme.weekday = weekday.value;
            /// hier viewmodel setzen (translate ?)
            $translate(weekday.name).then(function (translation) {
                dayscheme.vmWeekday = translation.substr(0, 3);
            });
            // generate times
            generateTimes(dayscheme);

            return dayscheme;

        } // generateDay

        // generate Time (hour, minute) of one day
        function generateTimes(day) {
            // times array 
            var times = [];

            // minutes to add
            var minutes = service.data.interval;

            // start time
            var now = new Date();
            now.setHours(DayStartEndTime.Start.hour);
            now.setMinutes(DayStartEndTime.Start.minute);
            now.setSeconds(0);
            now.setMilliseconds(0);

            // end time
            var end = new Date();
            end.setHours(DayStartEndTime.End.hour);
            end.setMinutes(DayStartEndTime.End.minute);
            end.setSeconds(0);

            // iterate till 24:00 pm reached
            while (now < end) {
                // new day scheme time object
                var time = new DaySchemeTime();
                time.init(now.getHours(), now.getMinutes());

                // iterate over existing times set to proof if time is existing
                var j = 0;
                var len = day.times.length;
                for (j = 0; j < len; j++) {
                    if (day.times[j] === null) { continue;}
                    // identical ?
                    if (now.getHours() === day.times[j].hour
                        && now.getMinutes() === day.times[j].minute) {
                        // found...

                        // extend object
                        time.extend(day.times[j]);

                        // remove object - so no more iterating -> set null
                        day.times[j] = null;                        

                    } //if
                } // for

                // add to array
                times.push(time);
                // add minutes
                now.setMinutes(now.getMinutes() + minutes);
            } // while

            // replace new array 
            day.times = null;
            day.times = times;
            times = null;
        } // generateTimes


        // init service
        function init(daySchemes, interval, weekStartDay) {
            // set interval
            service.data.interval = interval;
            service.data.weekStartDay = weekStartDay;
            // generate
            generate(daySchemes);
        } // init

        // select the whole day
        function selectDay(weekday) {
            // if copy in progress -> do nothing here
            if (weekday.vmCopyInProgress || weekday.vmPastePossible) { return; }

            // select all times of day
            weekday.times.forEach(function (item) {
                select(item);
            });

            // broadcast to items
            $rootScope.$broadcast(SchemeBroadcast.DaySelected);
        } // select day

        // select a cell and set label
        function select(cell) {
            // select
            cell.vmSelected = !cell.vmSelected;
            // label
            if (cell.vmSelected) {
                // label
                cell.agendaLabelDto = service.data.label;
                $rootScope.$broadcast(SchemeBroadcast.TimeSelected, cell);
            } //If
            else {
                cell.agendaLabelDto = null;
            }
        }

        // prepare for copy action
        function prepareForCopy(weekday) {
            var i = 0;
            var len = service.data.weekdays.length;
            // iterator over days and set that paste is possible 
            for (i = 0; i < len; i++) {
                if (weekday.weekday !== service.data.weekdays[i].weekday) {
                    // possible destinations of copy
                    service.data.weekdays[i].vmPastePossible = true;
                } //if
            } // for

            // source of copy
            weekday.vmCopyInProgress = true;
        }

        // stop copy action
        function stopCopy(weekday) {
            var i = 0;
            var len = service.data.weekdays.length;
            // iterator over days and reset copy paste
            for (i = 0; i < len; i++) {
                if (weekday.weekday !== service.data.weekdays[i].weekday) {
                    // possible destinations of copy
                    service.data.weekdays[i].vmPastePossible = false;
                } //if
            } // for

            // source of copy
            weekday.vmCopyInProgress = false;
        }


        // paste from source to current weekday
        function paste(weekday) {
            // get source day
            var source = $filter('filter')(service.data.weekdays, { 'vmCopyInProgress': true }, true)[0];
            if (source) {
                var i = 0;
                var len = weekday.times.length;
                for (i = 0; i < len; i++) {
                    // copy label
                    weekday.times[i].vmSelected = source.times[i].vmSelected;
                    weekday.times[i].agendaLabelDto = source.times[i].agendaLabelDto;
                } //for
            } // if

            // broadcast to items
            $rootScope.$broadcast(SchemeBroadcast.DaySelected);
        } 
    }
})();